import React from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import * as userActions from '../../../actions/user';
import * as searchActions from '../../../actions/search'
import * as loginActions from '../../../actions/login'
import s from './index.css';
import { COURSE_DETAIL, LIVE_COURSE, WEB_URL_INDEX } from '../../../config'
import { trackEventLog } from '../../../core/utils'
import Link from '../../common/Link'
import logo from './logo.png'
import SearchBox from '../SearchBox'
import history from '../../../core/history'

function formatTime(time) {
  const date = new Date(time);
  return `${date.getHours()}:${date.getMinutes() >= 10 ? date.getMinutes() : `0${date.getMinutes()}`}`
}

class Header extends React.Component {
  static defaultProps = {
    mycourseDisabled: false,
    loginDisabled: false,
  }

  componentDidMount() {
    const { remind, statusFetch, status, remindFetch, lowIe } = this.props
    // if (remind.length !== 0 || status.id || lowIe) return
    if (lowIe) return
    if (!status.id) {
      statusFetch()
    }
    if (remind.length === 0) {
      remindFetch()
    }
  }
  handleLogin = (e) => {
    const { setBackUrl } = this.props
    e.preventDefault()
    e.stopPropagation()
    trackEventLog('w/header/login')
    const backUrl = `${location.pathname}${location.search}`
    setBackUrl(backUrl)
    history.push('/login')
  }
  renderAside = () => {
    const { status, remind, cancelUserRemind, lowIe, loginOut,
      mycourseDisabled, loginDisabled } = this.props
    if (lowIe || loginDisabled) return null
    if (status.id) {
      return (
        <div>
          <div className={s.myCoursePanel}>
            <div className={s.myCourse}>
              {mycourseDisabled ?
                <a>我的课程</a> :
                <Link
                  to={'/user/mycourse'}
                  rel={'noreferrer'}
                  onClick={() => { trackEventLog('w/header/mycourse') }}
                >我的课程</Link>
              }
              {!remind.length ? null : <span className={s.dot} />}
            </div>
            {!remind.length ? null :
              <div className={s.remindWrapper}>
                <div className={s.remindCont}>
                  <div className={s.triangle} />
                  {remind.slice(0, 7).map((item, inx) => (
                    <div
                      className={s.remindItem}
                      key={`user-remind-${item.courseId}`}
                    >
                      <Link
                        rel={'noopener noreferrer'}
                        target={'_blank'}
                        to={item.type === 1 ?
                          `${LIVE_COURSE}?courseId=${item.courseId}&lesson=${item.lessonId}&liveId=${item.liveId}&groupId=${item.groupId || -1}` :
                          `${COURSE_DETAIL}${item.courseId}`}
                      >
                        <p className={s.title}>{item.courseTitle}</p>
                        <div className={item.type === 1 ? s.live : s.time}>{item.type === 1 ? '上课中' : `今日 ${formatTime(item.startTime)}课程`}</div>
                      </Link>
                      <span // eslint-disable-line
                        onClick={() => cancelUserRemind(inx)}
                        className={s.close}
                      >不再提醒</span>
                    </div>
                  ))}
                </div>
              </div>
            }
          </div>
          <div className={s.avatarPanel}>
            <div
              style={{ backgroundImage: `url(${status.avatar})` }}
              className={s.avatar}
            >
              <div className={s.imgBorder} />
            </div>
            <div className={s.userCont}>
              <div className={s.triangle} />
              <Link
                onClick={() => { trackEventLog('w/header/account2') }}
                className={`${s.userItem} ${s.accountItem}`}
                to={`${WEB_URL_INDEX}/user/account/`}
              >账户设置</Link>
              <Link
                onClick={() => { trackEventLog('w/header/order') }}
                className={`${s.userItem} ${s.orderItem}`}
                to={`${WEB_URL_INDEX}/user/order/`}
              >我的订单</Link>
              <span // eslint-disable-line
                className={`${s.userItem} ${s.logoutItem}`}
                onClick={async () => {
                  trackEventLog('w/header/logout')
                  if (mycourseDisabled) {
                    history.push('/')
                  }
                  const result = await loginOut()
                  if (result) window.location.reload()
                }}
              >退出</span>
            </div>
          </div>
        </div>
      )
    }
    if (process.env.BROWSER) {
      return (
        <a // eslint-disable-line
          onClick={this.handleLogin}
          rel={'noreferrer'}
          className={s.login}
        >登录</a>
      )
    }
    return null
  }

  render() {
    const { searchHistory, fetchSearch, lowIe, deleteSearchHistory, hotWords } = this.props

    return (
      <div className={s.root}>
        <div className={s.inner}>
          <Link
            to="/"
            onClick={(e) => {
              e.preventDefault(); // 阻止默认行为
              trackEventLog('w/header/logo');
              const url = new URL(window.location.origin);
              window.location.replace(url.toString());
            }}
            className={s.logoLink}
          >
            <img src={logo} className={s.logo} alt={'有道精品课'} />
          </Link>
          <div className={s.gap} />
          <Link
            onClick={(e) => {
              e.preventDefault(); // 阻止默认行为
              trackEventLog('w/header/index');
              const url = new URL(window.location.origin);
              window.location.replace(url.toString());
            }}
            to="/"
          >
            <span className={s.home}>首页</span>
          </Link>
          <Link
            onClick={() => { trackEventLog('w/header/tools') }}
            to="/download"
          >APP下载</Link>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={'https://study.163.com'}
          >网易云课堂</a>
          <a
            onClick={() => { trackEventLog('w/header/tongdao') }}
            target={'_blank'}
            rel={'noopener noreferrer'}
            href={'http://c.youdao.com/market/best/bestPc/index.html'}
          >同道计划</a>
          <a
            onClick={() => { trackEventLog('w/header/teacherinfo') }}
            target={'_blank'}
            rel={'noopener noreferrer'}
            href={'https://c.youdao.com/xue/wap/teachers.html'}
          >教师资格证公示</a>
          {/* 临时入口，之后会下线, 记得恢复搜索框宽度 */}
          {/* <a
            target="_blank"
            rel="noopener noreferrer"
            href={'https://c.youdao.com/xue/rectifyAnnounce.html'}
          >合规整改公告</a> */}
          {lowIe ? null :
            <SearchBox
              searchHistory={searchHistory}
              fetchSearch={fetchSearch}
              hotWords={hotWords}
              deleteSearchHistory={deleteSearchHistory}
            />}
          <div className={s.aside}>
            {this.renderAside()}
          </div>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  searchHistory: PropTypes.array,
  hotWords: PropTypes.array,
  status: PropTypes.object.isRequired,
  remind: PropTypes.array.isRequired,
  lowIe: PropTypes.bool.isRequired,
  fetchSearch: PropTypes.func.isRequired,
  statusFetch: PropTypes.func.isRequired,
  remindFetch: PropTypes.func.isRequired,
  deleteSearchHistory: PropTypes.func.isRequired,
  cancelUserRemind: PropTypes.func.isRequired,
  setBackUrl: PropTypes.func.isRequired,
  loginOut: PropTypes.func.isRequired,
  mycourseDisabled: PropTypes.bool,
  loginDisabled: PropTypes.bool,
};

Header.defaultProps = {
  hotWords: [],
  searchHistory: [],
}

function mapStateToProps(state) {
  return {
    searchHistory: state.search.searchHistory,
    hotWords: state.search.hotWords,
    status: state.user.status,
    remind: state.user.remind,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ...userActions,
    setBackUrl: loginActions.setBackUrl,
    fetchSearch: searchActions.fetchSearch,
    deleteSearchHistory: searchActions.deleteSearchHistory,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(s)(Header));



// WEBPACK FOOTER //
// ./src/components/global/Header/index.js